import React from "react";
import PropTypes from "prop-types";

const TableCell = ({ children, onClick, type }) => {
    return (
        <td className={`table__cell ${type}`} onClick={onClick}>
            {children}
        </td>
    );
};

TableCell.propTypes = { type: PropTypes.oneOf(["text", "bool", "currency"]) };
TableCell.defaultProps = { type: "text" };

export default TableCell;
